export default "__VITE_ASSET__DhgCuaN5__"